/* ============================================
   SEARCH — Luxire v2 Hotfix
   Features:
   1. Rotating placeholder text
   2. Recent searches (localStorage)
   3. Trending products (fetched from best-sellers)
   4. Autocomplete suggestion pills as you type
   5. Multi-type results: collections, products,
      articles, pages + "View all"
   ============================================ */

(function() {
  'use strict';

  var searchWrap    = document.querySelector('[data-search]');
  var searchInput   = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchDefault = document.querySelector('[data-search-default]');
  var suggestBar    = document.querySelector('[data-search-suggestions]');
  var trendingWrap  = document.querySelector('[data-trending-products]');
  var searchTimer   = null;
  var placeholderTimer = null;

  var RECENT_KEY  = 'luxire_recent_searches';
  var MAX_RECENT  = 5;

  if (!searchWrap || !searchInput || !searchResults) return;

  /* ──────────────────────────────────────────────
     SYNONYM MAP
     Each key maps to an array of equivalent terms.
     When a user searches for any term in a group,
     we also search for all other terms and merge.
     ────────────────────────────────────────────── */

  var SYNONYM_GROUPS = [
    ['pants', 'trousers', 'slacks'],
    ['shirt', 'shirts'],
    ['chinos', 'chino', 'khakis', 'khaki'],
    ['jeans', 'denim'],
    ['jacket', 'jackets', 'blazer', 'blazers', 'sport coat'],
    ['suit', 'suits', 'suiting'],
    ['linen', 'flax'],
    ['wool', 'woolen', 'woollen', 'merino'],
    ['cotton', 'poplin', 'broadcloth'],
    ['oxford', 'ocbd', 'oxford cloth'],
    ['gurkha', 'gurkhas'],
    ['polo', 'polo shirt', 'knit shirt'],
    ['dress shirt', 'formal shirt', 'business shirt'],
    ['casual shirt', 'sport shirt'],
    ['flannel', 'flannels'],
    ['corduroy', 'cord', 'cords'],
    ['tweed', 'twill'],
    ['slim', 'slim fit', 'tailored fit'],
    ['regular', 'regular fit', 'classic fit'],
    ['relaxed', 'relaxed fit', 'loose fit', 'wide leg'],
    ['pleated', 'pleats', 'pleat'],
    ['flat front', 'plain front'],
    ['cuff', 'cuffs', 'cuffed', 'turn-up', 'turn up'],
    ['button down', 'button-down', 'bd'],
    ['spread collar', 'cutaway collar', 'cutaway'],
    ['white', 'bright white', 'crisp white'],
    ['blue', 'light blue', 'sky blue'],
    ['navy', 'dark blue', 'navy blue'],
    ['grey', 'gray', 'charcoal'],
    ['cream', 'ecru', 'off-white', 'off white', 'ivory'],
    ['stripe', 'stripes', 'striped'],
    ['check', 'checks', 'checked', 'plaid'],
  ];

  /* Build lookup: word → list of synonyms (excluding itself) */
  var synonymLookup = {};
  SYNONYM_GROUPS.forEach(function(group) {
    group.forEach(function(term) {
      var lower = term.toLowerCase();
      synonymLookup[lower] = group.filter(function(t) {
        return t.toLowerCase() !== lower;
      });
    });
  });

  /**
   * Given a query string, find all synonym expansions.
   * Returns array of alternative query strings (may be empty).
   * Matches whole words and multi-word phrases.
   */
  function getSynonymQueries(query) {
    var qLower = query.toLowerCase().trim();
    var alternatives = [];
    var matched = {};

    /* Check multi-word phrases first (longest match) */
    var sortedKeys = Object.keys(synonymLookup).sort(function(a, b) {
      return b.length - a.length;
    });

    sortedKeys.forEach(function(term) {
      /* Word boundary check: term must appear as whole word(s) */
      var regex = new RegExp('(^|\\s|-)' + term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '($|\\s|-)', 'i');
      if (regex.test(qLower) && !matched[term]) {
        matched[term] = true;
        synonymLookup[term].forEach(function(syn) {
          var alt = qLower.replace(regex, function(match, pre, post) {
            return pre + syn + post;
          }).trim();
          if (alternatives.indexOf(alt) < 0 && alt !== qLower) {
            alternatives.push(alt);
          }
        });
      }
    });

    return alternatives;
  }

  /* ──────────────────────────────────────────────
     1. ROTATING PLACEHOLDER
     ────────────────────────────────────────────── */

  var placeholders = [
    'Search for oxford shirts…',
    'Search for gurkha pants…',
    'Search for linen fabrics…',
    'Search for chinos…',
    'Search for wool trousers…',
    'Search for polo shirts…',
    'Search for dress shirts…',
    'Search for jeans…'
  ];
  var placeholderIndex = 0;
  var isTypingPlaceholder = false;
  var typeTimer = null;

  function startPlaceholderRotation() {
    stopPlaceholderRotation();
    rotatePlaceholder();
    placeholderTimer = setInterval(rotatePlaceholder, 3500);
  }

  function stopPlaceholderRotation() {
    clearInterval(placeholderTimer);
    clearTimeout(typeTimer);
    placeholderTimer = null;
  }

  function rotatePlaceholder() {
    if (document.activeElement === searchInput && searchInput.value.length > 0) return;
    var text = placeholders[placeholderIndex];
    placeholderIndex = (placeholderIndex + 1) % placeholders.length;
    typeOutPlaceholder(text);
  }

  function typeOutPlaceholder(text) {
    var i = 0;
    isTypingPlaceholder = true;
    searchInput.setAttribute('placeholder', '');

    function typeNext() {
      if (i <= text.length) {
        searchInput.setAttribute('placeholder', text.substring(0, i));
        i++;
        typeTimer = setTimeout(typeNext, 35);
      } else {
        isTypingPlaceholder = false;
      }
    }
    typeNext();
  }

  /* ──────────────────────────────────────────────
     2. RECENT SEARCHES
     ────────────────────────────────────────────── */

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch(e) { return []; }
  }

  function addRecent(query) {
    var list = getRecent().filter(function(q) { return q.toLowerCase() !== query.toLowerCase(); });
    list.unshift(query);
    if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch(e) {}
  }

  function renderRecent() {
    var container = document.querySelector('[data-recent-searches]');
    if (!container) return;
    var recent = getRecent();
    if (recent.length === 0) { container.style.display = 'none'; return; }
    container.style.display = '';
    var html = '<div class="lx-search__default-title">Recent Searches</div><div class="lx-search__links">';
    recent.forEach(function(q) {
      html += '<a class="lx-search__recent-item" data-recent-query="' + escapeAttr(q) + '">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>'
        + escapeHtml(q) + '</a>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('[data-recent-query]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        searchInput.value = this.dataset.recentQuery;
        searchInput.dispatchEvent(new Event('input'));
      });
    });
  }

  /* ──────────────────────────────────────────────
     3. TRENDING PRODUCTS
     ────────────────────────────────────────────── */

  var trendingLoaded = false;

  function loadTrending() {
    if (trendingLoaded || !trendingWrap) return;
    trendingLoaded = true;

    fetch('/collections/best-sellers/products.json?limit=8')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products || [];
        if (products.length === 0) { trendingWrap.style.display = 'none'; return; }

        var html = '<div class="lx-search__default-title">Trending Now</div>';
        html += '<div class="lx-search__trending">';
        products.forEach(function(p) {
          var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_300x$1$2') : '';
          var price = '';
          if (p.variants && p.variants[0]) {
            price = formatMoney(p.variants[0].price);
          }
          html += '<a href="/products/' + p.handle + '" class="lx-search__product">';
          if (img) {
            html += '<div class="lx-search__product-img"><img src="' + img + '" alt="" loading="lazy"></div>';
          } else {
            html += '<div class="lx-search__product-img"></div>';
          }
          html += '<div class="lx-search__product-title">' + escapeHtml(p.title) + '</div>';
          if (price) html += '<div class="lx-search__product-price">' + price + '</div>';
          html += '</a>';
        });
        html += '</div>';
        trendingWrap.innerHTML = html;
      })
      .catch(function() {
        trendingWrap.style.display = 'none';
      });
  }

  /* ──────────────────────────────────────────────
     4. AUTOCOMPLETE SUGGESTIONS
     ────────────────────────────────────────────── */

  function renderSuggestions(products, collections, query) {
    if (!suggestBar) return;

    var suggestions = [];
    var seen = {};
    var qLower = query.toLowerCase();

    /* Extract suggestions from collection titles */
    collections.forEach(function(c) {
      var t = c.title;
      if (!seen[t.toLowerCase()]) {
        seen[t.toLowerCase()] = true;
        suggestions.push({ text: t, url: c.url, type: 'collection' });
      }
    });

    /* Extract product_type suggestions */
    products.forEach(function(p) {
      if (p.product_type && !seen[p.product_type.toLowerCase()]) {
        seen[p.product_type.toLowerCase()] = true;
        suggestions.push({ text: p.product_type, url: '/search?q=' + encodeURIComponent(p.product_type) + '&type=product,article,page', type: 'type' });
      }
    });

    /* Extract keyword suggestions from product titles */
    products.forEach(function(p) {
      var words = p.title.split(/[\s\-–]+/);
      words.forEach(function(w) {
        var clean = w.replace(/[^a-zA-Z0-9]/g, '');
        if (clean.length > 3 && clean.toLowerCase().indexOf(qLower) >= 0 && !seen[clean.toLowerCase()]) {
          seen[clean.toLowerCase()] = true;
          suggestions.push({ text: clean, url: '/search?q=' + encodeURIComponent(clean) + '&type=product,article,page', type: 'keyword' });
        }
      });
    });

    /* Limit to 6 */
    suggestions = suggestions.slice(0, 6);

    if (suggestions.length === 0) {
      suggestBar.style.display = 'none';
      return;
    }

    suggestBar.style.display = '';
    var html = '<span class="lx-search__suggestions-label">Try</span>';
    suggestions.forEach(function(s) {
      html += '<a href="' + s.url + '" class="lx-search__suggestion" data-suggest-query="' + escapeAttr(s.text) + '">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
        + highlightMatch(s.text, query)
        + '</a>';
    });
    suggestBar.innerHTML = html;

    /* Click suggestion → fill input and search */
    suggestBar.querySelectorAll('[data-suggest-query]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        searchInput.value = this.dataset.suggestQuery;
        searchInput.dispatchEvent(new Event('input'));
      });
    });
  }

  function highlightMatch(text, query) {
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx < 0) return escapeHtml(text);
    return escapeHtml(text.substring(0, idx))
      + '<span class="lx-search__suggestion-match">' + escapeHtml(text.substring(idx, idx + query.length)) + '</span>'
      + escapeHtml(text.substring(idx + query.length));
  }

  /* ──────────────────────────────────────────────
     5. MULTI-TYPE SEARCH RESULTS
     ────────────────────────────────────────────── */

  function renderResults(data, query, synonymsUsed) {
    var results = data.resources && data.resources.results || {};
    var products    = results.products    || [];
    var collections = results.collections || [];
    var pages       = results.pages       || [];
    var articles    = results.articles    || [];

    /* Autocomplete pills */
    renderSuggestions(products, collections, query);

    var total = products.length + collections.length + pages.length + articles.length;

    if (total === 0) {
      searchResults.innerHTML =
        '<div class="lx-search__empty">'
        + '<div class="lx-search__empty-title">No results for "' + escapeHtml(query) + '"</div>'
        + '<div class="lx-search__empty-text">Try a different search term or browse our collections</div>'
        + '</div>';
      if (searchDefault) searchDefault.style.display = 'none';
      return;
    }

    if (searchDefault) searchDefault.style.display = 'none';

    var html = '<div class="lx-search__body">';

    /* Synonym hint */
    if (synonymsUsed && synonymsUsed.length > 0) {
      html += '<div class="lx-search__synonym-hint">Also showing results for: '
        + synonymsUsed.map(function(s) { return '<strong>' + escapeHtml(s) + '</strong>'; }).join(', ')
        + '</div>';
    }

    /* Collections */
    if (collections.length > 0) {
      html += '<div class="lx-search__section">';
      html += '<div class="lx-search__section-head"><span class="lx-search__section-title">Collections</span></div>';
      html += '<div class="lx-search__collections">';
      collections.forEach(function(c) {
        html += '<a href="' + c.url + '" class="lx-search__collection-chip">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>'
          + escapeHtml(c.title)
          + '</a>';
      });
      html += '</div></div>';
    }

    /* Products */
    if (products.length > 0) {
      html += '<div class="lx-search__section">';
      html += '<div class="lx-search__section-head">';
      html += '<span class="lx-search__section-title">Products</span>';
      html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="lx-search__section-link">View all results →</a>';
      html += '</div>';
      html += '<div class="lx-search__products">';
      products.forEach(function(p) {
        var imgSrc = p.image ? sizedImage(p.image, '300x') : '';
        html += '<a href="' + p.url + '" class="lx-search__product">';
        if (imgSrc) {
          html += '<div class="lx-search__product-img"><img src="' + imgSrc + '" alt="" loading="lazy"></div>';
        } else {
          html += '<div class="lx-search__product-img"></div>';
        }
        html += '<div class="lx-search__product-title">' + escapeHtml(p.title) + '</div>';
        if (p.price) html += '<div class="lx-search__product-price">' + p.price + '</div>';
        html += '</a>';
      });
      html += '</div></div>';
    }

    /* Pages + Articles */
    var guides = [];
    pages.forEach(function(p) { guides.push({ title: p.title, url: p.url, type: 'Guide' }); });
    articles.forEach(function(a) { guides.push({ title: a.title, url: a.url, type: 'Article' }); });

    if (guides.length > 0) {
      html += '<div class="lx-search__section">';
      html += '<div class="lx-search__section-head"><span class="lx-search__section-title">Guides & Articles</span></div>';
      html += '<div class="lx-search__links">';
      guides.forEach(function(g) {
        html += '<a href="' + g.url + '" class="lx-search__link-item">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>'
          + escapeHtml(g.title)
          + '<span class="lx-search__link-type">' + g.type + '</span>'
          + '</a>';
      });
      html += '</div></div>';
    }

    /* View all */
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="lx-search__view-all">'
      + 'View all results for "' + escapeHtml(query) + '"'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
      + '</a>';

    html += '</div>';
    searchResults.innerHTML = html;

    addRecent(query);
  }

  /* ── Search input handler ── */

  searchInput.addEventListener('input', function() {
    var query = this.value.trim();
    clearTimeout(searchTimer);

    if (query.length < 2) {
      searchResults.innerHTML = '';
      if (searchDefault) searchDefault.style.display = '';
      if (suggestBar) suggestBar.style.display = 'none';
      renderRecent();
      return;
    }

    showLoading();

    searchTimer = setTimeout(function() {
      var synonymQueries = getSynonymQueries(query);
      var allQueries = [query].concat(synonymQueries);

      /* Fire all searches in parallel */
      var fetches = allQueries.map(function(q) {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product,collection,page,article'
          + '&resources[limit]=10'
          + '&resources[options][fields]=title,product_type,vendor,tag,body';
        return fetch(url).then(function(r) { return r.json(); }).catch(function() { return null; });
      });

      Promise.all(fetches).then(function(results) {
        var merged = mergeResults(results);
        var synonymsUsed = synonymQueries.length > 0 ? synonymQueries : null;
        renderResults(merged, query, synonymsUsed);
      }).catch(function() {
        searchResults.innerHTML =
          '<div class="lx-search__body"><div class="lx-search__empty">'
          + '<div class="lx-search__empty-title">Something went wrong</div>'
          + '<div class="lx-search__empty-text">Please try again</div>'
          + '</div></div>';
      });
    }, 250);
  });

  /**
   * Merge multiple Shopify suggest API responses.
   * Deduplicates by URL, preserves order (primary query first).
   */
  function mergeResults(responses) {
    var products = [], collections = [], pages = [], articles = [];
    var seenProducts = {}, seenCollections = {}, seenPages = {}, seenArticles = {};

    responses.forEach(function(data) {
      if (!data || !data.resources || !data.resources.results) return;
      var r = data.resources.results;

      (r.products || []).forEach(function(p) {
        if (!seenProducts[p.url]) { seenProducts[p.url] = true; products.push(p); }
      });
      (r.collections || []).forEach(function(c) {
        if (!seenCollections[c.url]) { seenCollections[c.url] = true; collections.push(c); }
      });
      (r.pages || []).forEach(function(p) {
        if (!seenPages[p.url]) { seenPages[p.url] = true; pages.push(p); }
      });
      (r.articles || []).forEach(function(a) {
        if (!seenArticles[a.url]) { seenArticles[a.url] = true; articles.push(a); }
      });
    });

    /* Wrap in Shopify-like structure */
    return {
      resources: {
        results: {
          products: products.slice(0, 10),
          collections: collections.slice(0, 5),
          pages: pages.slice(0, 3),
          articles: articles.slice(0, 3)
        }
      }
    };
  }

  /* Enter → full search page */
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      var query = this.value.trim();
      if (query.length > 0) {
        addRecent(query);
        window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product,article,page';
      }
    }
  });

  /* Stop placeholder rotation when user starts typing */
  searchInput.addEventListener('focus', function() {
    if (this.value.length > 0) stopPlaceholderRotation();
  });
  searchInput.addEventListener('input', function() {
    if (this.value.length > 0) stopPlaceholderRotation();
    else startPlaceholderRotation();
  });

  /* ──────────────────────────────────────────────
     OPEN / CLOSE
     ────────────────────────────────────────────── */

  function openSearch() {
    searchWrap.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    searchResults.innerHTML = '';
    if (searchDefault) searchDefault.style.display = '';
    if (suggestBar) suggestBar.style.display = 'none';
    renderRecent();
    loadTrending();
    startPlaceholderRotation();
    setTimeout(function() { searchInput.focus(); }, 100);
  }

  function closeSearch() {
    searchWrap.classList.remove('is-open');
    document.body.style.overflow = '';
    searchInput.value = '';
    searchResults.innerHTML = '';
    if (suggestBar) suggestBar.style.display = 'none';
    stopPlaceholderRotation();
  }

  document.querySelectorAll('[data-search-open]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); openSearch(); });
  });
  document.querySelectorAll('[data-search-close]').forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });

  /* Close on overlay click */
  searchWrap.addEventListener('click', function(e) {
    if (e.target === searchWrap) closeSearch();
  });

  /* Close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchWrap.classList.contains('is-open')) closeSearch();
  });

  /* ──────────────────────────────────────────────
     HELPERS
     ────────────────────────────────────────────── */

  function showLoading() {
    searchResults.innerHTML =
      '<div class="lx-search__body"><div class="lx-search__loading">'
      + '<div class="lx-search__spinner"></div><span>Searching…</span>'
      + '</div></div>';
    if (searchDefault) searchDefault.style.display = 'none';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;');
  }

  function sizedImage(url, size) {
    if (!url) return '';
    return url.replace(/(\.\w+)(\?|$)/, '_' + size + '$1$2');
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    /* Fallback: use store currency or default to $ */
    var amount = (parseFloat(cents) / 100).toFixed(2);
    var symbol = '$';
    if (typeof window.shopCurrency !== 'undefined') {
      if (window.shopCurrency === 'EUR') symbol = '€';
      else if (window.shopCurrency === 'GBP') symbol = '£';
      else if (window.shopCurrency === 'INR') symbol = '₹';
      else if (window.shopCurrency === 'SEK' || window.shopCurrency === 'NOK' || window.shopCurrency === 'DKK') symbol = 'kr ';
    }
    return symbol + amount;
  }

})();
